import styled from '@emotion/styled';

export const CardWrapper = styled.div`
  width: 100%;
  flex: 1;
`;
